export { PageLandingPageComponent as PageLandingPage } from './component';



// WEBPACK FOOTER //
// ./src/pages/landing-page/index.tsx